import { render, staticRenderFns } from "./MultipleTabsOverlay.vue?vue&type=template&id=0dd3df23&"
import script from "./MultipleTabsOverlay.vue?vue&type=script&lang=js&"
export * from "./MultipleTabsOverlay.vue?vue&type=script&lang=js&"
import style0 from "./MultipleTabsOverlay.vue?vue&type=style&index=0&id=0dd3df23&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports